export default "__VITE_PUBLIC_ASSET__b75070c8__"